exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-header .close {\n  font-size: 38px;\n}\n", ""]);

// exports
